import { render, staticRenderFns } from "./DeviceModelFormModal.vue?vue&type=template&id=71fc8036&"
import script from "./DeviceModelFormModal.vue?vue&type=script&lang=js&"
export * from "./DeviceModelFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports